/* Emoji.tsx generated by @compiled/babel-plugin v3.0.2 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._313842A17z%7Bmargin-top%3A-1px%7D%0A._0adFHsdnbC%7Bmargin-right%3A0%7D%0A._1DCdHiA17z%7Bmargin-bottom%3A-1px%7D%0A._2XsHFMdnbC%7Bmargin-left%3A0%7D%0A._3iDTPbvbI6%7Bdisplay%3Ainline-block%7D%0A._1iPKDrNZfY%20.emoji-common-emoji-sprite%7Bbackground%3Atransparent%20no-repeat%7D%0A._2hB4kovbI6%20.emoji-common-emoji-sprite%7Bdisplay%3Ainline-block%7D%0A._1GBPVvSPN1%20.emoji-common-emoji-sprite%7Bmin-height%3A20px%7D%0A._3woHNtSPN1%20.emoji-common-emoji-sprite%7Bmin-width%3A20px%7D%0A._2oqNm2t2nV%20.emoji-common-emoji-sprite%7Bvertical-align%3Amiddle%7D%0A._1XjlOoo126.emoji-common-select-on-hover%3Ahover%7Bbackground-color%3Avar(--ds-background-neutral-subtle-hovered%2C%230515240f)%7D%0A._0eVgdoo126.emoji-common-selected%7Bbackground-color%3Avar(--ds-background-neutral-subtle-hovered%2C%230515240f)%7D%0A._1zr6Dc98eZ%3Afocus%7Boutline-color%3AcurrentColor%7D%0A._0htemXYbGa%3Afocus%7Boutline-style%3Anone%7D%0A._067LceT6kp%3Afocus%7Boutline-width%3Amedium%7D%0A._0ui43C1O6y%3Afocus%7Bbox-shadow%3A0%200%200%202px%20var(--ds-border-focused%2C%234688ec)%7D%0A._0hot5EBMeg%3Afocus%7Btransition-duration%3A0s%2C.2s%7D%0A._0bjKvDzXzM%7Bborder-radius%3Avar(--ds-radius-small%2C3px)%7D%0A._0KLXrujOvk%7Bbackground-color%3Atransparent%7D%0A._1RrJLit2nV%7Bvertical-align%3Amiddle%7D%0A._23odCivLZJ%20img%7Bdisplay%3Ablock%7D%0A._2LVIB7YvD1.emoji-common-select-on-hover%3Ahover%20.emoji-common-deleteButton%7Bvisibility%3Avisible%7D%0A._4jXNFKYvD1.emoji-common-selected%7Bvisibility%3Avisible%7D%0A._3JWaHCRAKS.emoji-common-deletable%7Bposition%3Arelative%7D%0A._1MkY46YvD1.emoji-common-deletable%3Afocus-within%20.emoji-common-deleteButton%7Bvisibility%3Avisible%7D");
























import React, { useEffect, useContext, type FocusEvent, type MouseEvent, forwardRef, type PropsWithChildren } from 'react';
import { IntlContext } from 'react-intl';
import { expValEquals } from '@atlaskit/tmp-editor-statsig/exp-val-equals';
import Tooltip from '@atlaskit/tooltip/Tooltip';
import { type EmojiDescription, type OnEmojiEvent, UfoEmojiTimings } from '../../types';
import { hasUfoMarked } from '../../util/analytics/hasUfoMarked';
import { sampledUfoRenderedEmoji } from '../../util/analytics/sampledUfoRenderedEmoji';
import { ufoExperiences } from '../../util/analytics/ufoExperiences';
import { useSampledUFOComponentExperience } from '../../util/analytics/useSampledUFOComponentExperience';
import { deleteEmojiLabel, EMOJI_KEYBOARD_KEYS_SUPPORTED, KeyboardKeys, SAMPLING_RATE_EMOJI_RENDERED_EXP } from '../../util/constants';
import { isSpriteRepresentation } from '../../util/is-sprite-representation';
import { leftClick } from '../../util/left-click';
import { toEmojiId } from '../../util/to-emoji-id';
import { messages } from '../i18n';
import { handleDelete } from './handleDelete';
import { ImageEmoji } from './ImageEmoji';
import { SpriteEmoji } from './SpriteEmoji';
const emojiSpriteContainer = null;
const emojiImageContainer = null;
export interface Props extends Omit<React.HTMLAttributes<HTMLSpanElement>, 'onMouseMove' | 'onFocus'> {
  /**
   * Auto Width takes the constraint of height and enables native scaling based on the emojis image.
   * This is primarily used when rendering emojis for SSR as the component does not know the width and height
   * at the time of the render. It overrides the emoji representations width with 'auto' on the images width attribute
   *
   * Used only for image based emojis
   */
  autoWidth?: boolean;

  /**
   * Additional css classes, if required.
   */
  className?: string;

  /**
   * Disables lazy load on images
   */
  disableLazyLoad?: boolean;

  /**
   * This should only be set when the emoji is being used in the Editor.
   * Currently when set -- this prevents any aria labels being added.
   * This is acceptable in Editor -- as it uses another technique to announce the emoji nodes.
   */
  editorEmoji?: true;

  /**
   * The emoji to render
   */
  emoji: EmojiDescription;

  /**
   * Fits emoji to height in pixels, keeping aspect ratio
   */
  fitToHeight?: number;

  /**
   * When true, the emoji is treated as decorative (purely visual).
   * This removes the aria-label so screen readers will skip the emoji.
   */
  isDecorative?: boolean;

  /**
   * Called when an emoji is deleted
   */
  onDelete?: OnEmojiEvent;

  /**
   * Called when the mouse moves over the emoji.
   */
  onFocus?: OnEmojiEvent;

  /**
   * Callback for if an emoji image fails to load.
   */
  onLoadError?: OnEmojiEvent<HTMLImageElement>;

  /**
   * Callback for if an emoji image succesfully loads.
   */
  onLoadSuccess?: (emoji: EmojiDescription) => void;

  /**
   * Called when the mouse moves over the emoji.
   */
  onMouseMove?: OnEmojiEvent;

  /**
   * Called when an emoji is selected
   */
  onSelected?: OnEmojiEvent;

  /**
   * Prevent mouse selection from moving browser focus to the emoji.
   * Keyboard selection still keeps focus on the emoji for grid navigation.
   */
  preventFocusOnMouseDown?: boolean;

  /**
   * Show the emoji as selected
   */
  selected?: boolean;

  /**
   * Automatically show the emoji as selected based on mouse hover.
   * CSS, fast, does not require a re-render, but selected state not
   * externally controlled via props.
   */
  selectOnHover?: boolean;

  /**
   * Indicates whether emoji is an interactive element (tab index and role) or just a view
   */
  shouldBeInteractive?: boolean;

  /**
   * Show a delete button on mouse hover
   * Used only for custom emoji
   */
  showDelete?: boolean;

  /**
   * Show a tooltip on mouse hover.
   */
  showTooltip?: boolean;
}
const handleMouseDown = (props: Props, event: MouseEvent<any>) => {
  // Clicked emoji delete button
  if (event.target instanceof Element && event.target.getAttribute('aria-label') === deleteEmojiLabel) {
    return;
  }
  const {
    emoji,
    onSelected
  } = props;
  if (onSelected && leftClick(event)) {
    if (props.preventFocusOnMouseDown) {
      event.preventDefault();
    }
    onSelected(toEmojiId(emoji), emoji, event);
  }
};
const handleKeyDown = (props: Props, event: React.KeyboardEvent<HTMLElement>) => {
  if (!EMOJI_KEYBOARD_KEYS_SUPPORTED.includes(event.key)) {
    return;
  }
  event.preventDefault();
  event.stopPropagation();
  const {
    emoji,
    onSelected,
    showDelete
  } = props;
  if (onSelected && (event.key === KeyboardKeys.Enter || event.key === KeyboardKeys.Space)) {
    onSelected(toEmojiId(emoji), emoji, event);
  }
  if (showDelete && event.key === KeyboardKeys.Backspace) {
    handleDelete(props, event);
  }
};
const handleMouseMove = (props: Props, event: MouseEvent<any>) => {
  const {
    emoji,
    onMouseMove
  } = props;
  if (onMouseMove) {
    onMouseMove(toEmojiId(emoji), emoji, event);
  }
};
const handleFocus = (props: Props, event: FocusEvent<any>) => {
  const {
    emoji,
    onFocus
  } = props;
  if (onFocus) {
    onFocus(toEmojiId(emoji), emoji, event);
  }
};
interface EmojiNodeWrapperProps extends Props {
  type: 'sprite' | 'image';
}
export const EmojiNodeWrapper: React.ForwardRefExoticComponent<EmojiNodeWrapperProps & {
  children?: React.ReactNode | undefined;
} & React.RefAttributes<HTMLSpanElement>> = forwardRef<HTMLSpanElement, PropsWithChildren<EmojiNodeWrapperProps>>((props, ref) => {
  const {
    emoji,
    fitToHeight,
    selected,
    selectOnHover,
    className,
    showTooltip,
    showDelete,
    shouldBeInteractive = false,
    tabIndex,
    onSelected,
    onMouseMove,
    onFocus,
    onDelete,
    onLoadError,
    onLoadSuccess,
    disableLazyLoad,
    autoWidth,
    children,
    type,
    editorEmoji,
    isDecorative,
    ...other
  } = props;
  const intl = useContext(IntlContext);
  const isAriaLabelEmpty = editorEmoji || isDecorative;
  let ariaLabel: string | undefined;
  if (isAriaLabelEmpty) {
    ariaLabel = undefined;
  } else if (intl) {
    ariaLabel = intl.formatMessage(messages.changeEmojiShortnameButtonLabel, {
      shortName: emoji.name ?? emoji.shortName
    });
  } else {
    ariaLabel = emoji.shortName;
  }
  const tooltipContent = showTooltip && expValEquals('platform_editor_emoji_hover_show_tooltip', 'isEnabled', true) ? emoji.shortName || emoji.name || undefined : undefined;
  const emojiSpan = <span role={editorEmoji ? undefined : shouldBeInteractive ? 'button' : ariaLabel ? 'img' : 'presentation'} aria-label={ariaLabel} ref={ref} data-testid={`${type}-emoji-${emoji.shortName}`} data-emoji-type={type} tabIndex={shouldBeInteractive ? tabIndex || 0 : undefined}
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
  className={ax([type === 'sprite' ? "_313842A17z _0adFHsdnbC _1DCdHiA17z _2XsHFMdnbC _3iDTPbvbI6 _1iPKDrNZfY _2hB4kovbI6 _1GBPVvSPN1 _3woHNtSPN1 _2oqNm2t2nV _1XjlOoo126 _0eVgdoo126 _1zr6Dc98eZ _0htemXYbGa _067LceT6kp _0ui43C1O6y _0hot5EBMeg" : "_0bjKvDzXzM _313842A17z _0adFHsdnbC _1DCdHiA17z _2XsHFMdnbC _0KLXrujOvk _3iDTPbvbI6 _1RrJLit2nV _23odCivLZJ _1XjlOoo126 _0eVgdoo126 _2LVIB7YvD1 _4jXNFKYvD1 _3JWaHCRAKS _1MkY46YvD1 _1zr6Dc98eZ _0htemXYbGa _067LceT6kp _0ui43C1O6y _0hot5EBMeg", className])} onKeyDown={event => handleKeyDown(props, event)} onMouseDown={event => {
    handleMouseDown(props, event);
  }} onMouseEnter={event => {
    handleMouseMove(props, event);
  }} onFocus={event => {
    handleFocus(props, event);
  }} title={showTooltip && !expValEquals('platform_editor_emoji_hover_show_tooltip', 'isEnabled', true) ? emoji.shortName : undefined} {...other}>
			{children}
		</span>;
  if (tooltipContent) {
    return <Tooltip content={tooltipContent} isScreenReaderAnnouncementDisabled position="top" tag="span">
				{emojiSpan}
			</Tooltip>;
  }
  return emojiSpan;
});
export const Emoji = (props: Props): JSX.Element => {
  const {
    emoji
  } = props;
  // start emoji rendered experience, it may have already started earlier in ResourcedEmoji or CachingEmoji
  useSampledUFOComponentExperience(ufoExperiences['emoji-rendered'].getInstance(emoji.id || emoji.shortName), SAMPLING_RATE_EMOJI_RENDERED_EXP, {
    source: 'Emoji',
    emojiId: emoji.id
  });
  useEffect(() => {
    const ufoExp = sampledUfoRenderedEmoji(emoji);
    if (!hasUfoMarked(ufoExp, 'fmp')) {
      ufoExp.markFMP();
    }
    if (!hasUfoMarked(ufoExp, UfoEmojiTimings.MOUNTED_END)) {
      ufoExp.mark(UfoEmojiTimings.MOUNTED_END);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // TODO: We always prefer render as image as having accessibility issues with sprite representation
  if (isSpriteRepresentation(emoji.representation)) {
    return <SpriteEmoji {...props} />;
  }
  return <ImageEmoji {...props} />;
};
export default Emoji;